import { Link } from "react-router-dom";
import type { ReactNode } from "react";

export function AuthScreen({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children: ReactNode;
}) {
  return (
    <main className="grid min-h-[100dvh] lg:grid-cols-2">
      <section className="hidden flex-col justify-between bg-primary px-14 py-10 text-primary-foreground lg:flex">
        <p className="text-sm font-medium text-white/80">ISKCON Pune · BCEC</p>
        <div className="max-w-sm">
          <p className="text-4xl font-semibold tracking-tight">HR portal</p>
          <p className="mt-4 text-lg text-white/85">
            People, leave, hours, and the work of the day.
          </p>
        </div>
        <p className="text-sm text-white/70">BCEC staff only.</p>
      </section>
      <section className="flex items-center justify-center bg-background px-6 py-12">
        <div className="w-full max-w-sm">
          <p className="text-sm font-medium text-primary lg:hidden">ISKCON Pune · BCEC</p>
          <h1 className="mt-2 text-2xl font-semibold tracking-tight">{title}</h1>
          <p className="mt-2 text-sm text-muted-foreground">{description}</p>
          <div className="mt-8">{children}</div>
          <p className="mt-6 text-sm text-muted-foreground">
            <Link
              to="/"
              className="cursor-pointer font-medium text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              Choose a different sign-in
            </Link>
          </p>
        </div>
      </section>
    </main>
  );
}
